import type { CanBePorscheApproved, DisablementReason } from "@slfinrtl/ui-bff-routes"
import type { MessageDescriptor } from "react-intl"
import { porscheApprovedMessages } from "src/common/messages/porscheApproved.messages"
import { isDealerDecisionValid } from "./isDealerDecisionValid"

export const useDisablementReasons = (
	view:
		| {
				canBePorscheApproved: CanBePorscheApproved
				dealerDecisionPorscheApproved: boolean | undefined
		  }
		| undefined,
): MessageDescriptor[] => {
	if (!view || view.canBePorscheApproved.ok || !isDealerDecisionValid(view)) {
		return []
	}

	return view.canBePorscheApproved.violationReasons.map(mapViolationReasonToMessage).filter((v) => !!v)
}

export const mapViolationReasonToMessage = (violationReason: DisablementReason): MessageDescriptor | undefined => {
	switch (violationReason) {
		case "DERIVATIVE_NOT_ALLOWED":
			return porscheApprovedMessages.violationReasonDerivativeNotAllowed
		case "MILEAGE_LIMIT_EXCEEDED":
			return porscheApprovedMessages.violationReasonMileageLimitExceeded
		case "MODEL_SERIES_NOT_ALLOWED":
			return porscheApprovedMessages.violationReasonModelSeriesNotAllowed
		case "IS_NEW_CAR":
			return porscheApprovedMessages.violationReasonIsNewCar
		case "USED_CAR_WARRANTY_PRODUCT_NOT_AVAILABLE_IN_MARKET":
			return porscheApprovedMessages.violationReasonUsedCarWarrantyProductNotAvailableInMarket
		case "NEW_MARKET_MINIMUM_WARRANTY_RUNTIME_EXCEEDS_VEHICLE_AGE":
			return porscheApprovedMessages.violationReasonNewMarketMinimumWarrantyRuntimeExceedsVehicleAge
		case "RESIDUAL_WARRANTY_INSUFFICIENT_FOR_MARKET_MINIMUM_STANDARD":
			return porscheApprovedMessages.violationReasonResidualWarrantyInsufficientForMarketMinimumStandard
		case "RESIDUAL_WARRANTY_IS_NOT_CONSIDERED_IN_THIS_MARKET":
			return porscheApprovedMessages.violationReasonResidualWarrantyIsNotConsideredInThisMarket
		case "WARRANTY_OPTION_RUNTIME_EXCEEDS_VEHICLE_AGE":
			return porscheApprovedMessages.violationReasonWarrantyOptionRuntimeExceedsVehicleAge
		case "MANDATORY_BUT_NOT_POSSIBLE":
			return porscheApprovedMessages.violationReasonMandatoryButNotPossible
		case "NOT_ENOUGH_REMAINING_WARRANTY":
			return porscheApprovedMessages.violationReasonResidualWarrantyInsufficientForMarketMinimumStandard
		case "VEHICLE_NOT_HOMOLOGATED_IN_MARKET":
			return porscheApprovedMessages.violationReasonVehicleNotHomologatedInMarket
	}
}
